module.exports = __webpack_public_path__ + "static/media/dare-drop.6879bf4f.webp";